import { Routes } from '@angular/router';
import { PrivacyGuard } from './shared/guards/privacy.guard';


export const routes: Routes = [

  {
    path: 'privacy/:uuid',
    loadComponent: () => import('./components/privacy/privacy.component').then(m => m.PrivacyComponent)
  },
  {
    path: 'registration/:uuid',
    loadComponent: () => import('./components/registration/registration.component').then(m => m.RegistrationComponent),
    canActivate: [PrivacyGuard]
  },
  {
    path: 'wrong-link',
    loadComponent: () => import('./components/wrong-link/wrong-link.component').then(m => m.WrongLinkComponent),
  },
  {
    path: 'success',
    loadComponent: () => import('./shared/components/submission-success/submission-success.component').then(m => m.SubmissionSuccessComponent),
  },
  {
    path:'**',redirectTo:'/',pathMatch:'full'
  }
];
